import React from 'react';
import Rodal from 'rodal';
import { Link } from 'react-router-dom';

const defaultArray = [];
const DashboardModal = ({
  isOpen,
  onClose,
  onClick,
  card,
  usages = defaultArray,
  history,
  user,
  onSignUp,
  onLogout,
}) => {
  const { id, title, text, abilities = defaultArray } = card;
  const handleClick = () => {
    onClick(id, title);
    onClose();
  };
  return (
    <Rodal width={960} height={560} visible={isOpen} onClose={onClose}>
      <div className="modal_content">
        <h2 className="heading">{title}</h2>
        <br />
        <div className="">{text}</div>
        <br />
        <div className="row abilities">
          {abilities.map(({ icon, text }) => (
            <div key={text} className="col content">
              <div className=" icon_wrapper">
                <img src={icon} alt="icon" />
              </div>
              <div className="">{text}</div>
            </div>
          ))}
        </div>
        <hr />
        <h3>Use it for</h3>
        <div className="row usages">
          {usages.map(({ icon, text }) => (
            <div key={text} className="row content">
              <div className="col-3 icon_wrapper">
                <img src={icon} alt="icon" />
              </div>
              <div className="col-9">{text}</div>
            </div>
          ))}
        </div>
        <hr />
        <h3>GET STARTED</h3>
        <br />
        {user && user.guest ? (
          <>
            <p>
              <Link to={' '} onClick={onSignUp}>
                Sign up
              </Link>{' '}
              to create your own POPin!
            </p>
            <p>
              Already have an account?{' '}
              <Link to={' '} onClick={onLogout}>
                Log out
              </Link>{' '}
              of your Guest account and log back in with your work email.
            </p>
          </>
        ) : (
          <button
            onClick={handleClick}
            className="btn btn-lg btn-primary btn-submit"
          >
            Create a {title} Session
          </button>
        )}
      </div>
    </Rodal>
  );
};

export default DashboardModal;
